<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">A chi è rivolto il risparmio finalizzato?</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-3">
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.firstName" type="text" class="form-control" id="firstName" placeholder="Nome" required="" >
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.lastName" type="text" class="form-control" id="firstName" placeholder="Cognome" required="" >
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.dateOfBirth" @change="checkAge(formData.contractFigure.dateOfBirth)" :type="formData.contractFigure.dateOfBirth == null ? 'text' : 'date'" class="form-control" id="dob" placeholder="Data di nascita" onfocus="(this.type='date')" required=""> 
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.address" type="text" class="form-control" id="address" placeholder="Indirizzo" required="" >
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.email" type="text" class="form-control" id="email" placeholder="Email" required="" >
                </div>
                <div class="col-sm-6">
                    <input v-model="formData.contractFigure.telephone" type="number" class="form-control" id="telephone" placeholder="Telefono" required="" >
                </div>
            </div>
            
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>

    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ToWhomSelfScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        personType: null,
                        contractFigure: {
                            firstName: null,
                            lastName: null,
                            dateOfBirth: null,
                            address: null,
                            email: null,
                            telephone: null,
                        }
                    }
                }
            }
            
        },
        data() {
            return {
                errors: []
            }
        },
        methods: {
            checkAge(birthday) {
                let today = new Date();
                let dateOfBirth = new Date(birthday);
                let days = (today.getUTCFullYear() - dateOfBirth.getUTCFullYear()) * 360 + (today.getUTCMonth() - dateOfBirth.getUTCMonth()) * 30 + (today.getUTCDate() - dateOfBirth.getUTCDate());
                let age = Math.round(days/360);
                if ((age < 18) || (age > 78)) {
                    this.errors = [];
                    this.errors.push("Età non valida");
                    return false;
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf("Età non valida");
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
                return true;
            },
            validateForm() {
                this.errors = [];
                if (!this.formData.contractFigure.firstName || this.formData.contractFigure.firstName == "") {
                    this.errors.push("Nome contraente mancante");
                }
                if (!this.formData.contractFigure.lastName || this.formData.contractFigure.lastName == "") {
                    this.errors.push("Cognome contraente mancante");
                }
                if (!this.formData.contractFigure.address  || this.formData.contractFigure.address == "") {
                    this.errors.push("Indirizzo contraente mancante");
                }
                if (!this.checkAge(this.formData.contractFigure.dateOfBirth)) {}
                if (!this.formData.contractFigure.dateOfBirth  || this.formData.contractFigure.dateOfBirth == "") {
                    this.errors.push("Età contraente non valida o mancante");
                }
                if (!this.formData.contractFigure.email  || this.formData.contractFigure.email == "") {
                    this.errors.push("Email contraente mancante");
                }
                if (!this.formData.contractFigure.telephone  || this.formData.contractFigure.telephone == "") {
                    this.errors.push("Telefono contraente mancante");
                }
                

                if (this.errors.length === 0) {
                     if (this.formData.contractFigure.firstName && this.formData.contractFigure.lastName && 
                    this.formData.contractFigure.dateOfBirth && this.formData.contractFigure.address && 
                    this.formData.contractFigure.email && this.formData.contractFigure.telephone ) {
                    this.$emit('save-form-data-event', this.formData);
                    this.$emit('go-to-event', 'RealizeSelfScreenId');
                    return true;
                }
                }
               

                
            }
        }
    }
</script>